import { APP_CONSTANTS } from 'src/consumer/constants'

import CalendarMonth from '@mui/icons-material/CalendarMonth'
import Home from '@mui/icons-material/Home'
import { useNavigate } from 'react-router'
import React from 'react'
import { SidebarItemContainer } from 'src/clinic/components/ClinicSidebar/ClinicSidebarStyles'
import { SidebarContainer, SidebarItemText, StyledLogo } from './styledComponents'
import { getUserRoles } from 'src/mentor/layout/utils'
import { _supportNav } from '../navigation/_nav'

export default function SupportSidebar() {
  const navigate = useNavigate()
  const sidebarIconSx = {
    fontSize: { xs: '30px', md: '40px' },
    color: '#fff',
  }
  const rolesInBool = getUserRoles()

  const navs = _supportNav(rolesInBool)

  return (
    <SidebarContainer>
      <StyledLogo 
        src={APP_CONSTANTS.APP_LOGO_LINK} 
        onError={(e) => {
          e.target.src = '/logo_brand.png'
        }}
        onClick={() => navigate('/support-home')} 
      />
      {navs?.map((navItem) => (
        <div
          key={navItem?.id}
          className="d-flex align-items-center justify-content-start gap-2 w-100 sidebar-item"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(navItem.to)}
        >
          <navItem.icon sx={sidebarIconSx} />
          <SidebarItemContainer className="sidebar-item-text">
            <SidebarItemText>{navItem?.name}</SidebarItemText>
          </SidebarItemContainer>
        </div>
      ))}
    </SidebarContainer>
  )
}
